import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class LastUpdateBroadcaster {
    public event: EventEmitter<any> = new EventEmitter<any>();
}


// WEBPACK FOOTER //
// ./src/app/core/broadcasts/last-updated-broadcaster.ts